// 게임 보드 크기
export const BOARD_WIDTH = 10;
export const BOARD_HEIGHT = 20;

// 빈 보드 생성
export const createBoard = () => {
  return Array.from({ length: BOARD_HEIGHT }, () =>
    Array(BOARD_WIDTH).fill('#000')
  );
};

// 충돌 감지
export const checkCollision = (player, board, { x: moveX, y: moveY }) => {
  for (let y = 0; y < player.tetromino.shape.length; y++) {
    for (let x = 0; x < player.tetromino.shape[y].length; x++) {
      if (player.tetromino.shape[y][x] !== 0) {
        const newY = y + player.pos.y + moveY;
        const newX = x + player.pos.x + moveX;

        if (
          newY < 0 ||
          newY >= BOARD_HEIGHT ||
          newX < 0 ||
          newX >= BOARD_WIDTH ||
          board[newY][newX] !== '#000'
        ) {
          return true;
        }
      }
    }
  }
  return false;
};

// 테트로미노 회전
export const rotate = (matrix) => {
  const rotated = matrix.map((_, index) =>
    matrix.map(col => col[index])
  );
  return rotated.map(row => row.reverse());
};

// 보드에 테트로미노 병합
export const mergeTetromino = (board, player) => {
  const newBoard = board.map(row => [...row]);

  player.tetromino.shape.forEach((row, y) => {
    row.forEach((value, x) => {
      if (value !== 0) {
        const boardY = y + player.pos.y;
        const boardX = x + player.pos.x;
        if (boardY >= 0 && boardY < BOARD_HEIGHT && boardX >= 0 && boardX < BOARD_WIDTH) {
          newBoard[boardY][boardX] = player.tetromino.color;
        }
      }
    });
  });

  return newBoard;
};

// 완성된 라인 제거
export const clearLines = (board) => {
  let linesCleared = 0;
  const newBoard = board.filter(row => {
    if (row.every(cell => cell !== '#000')) {
      linesCleared++;
      return false;
    }
    return true;
  });

  while (newBoard.length < BOARD_HEIGHT) {
    newBoard.unshift(Array(BOARD_WIDTH).fill('#000'));
  }

  return { board: newBoard, linesCleared };
};

// 테트로미노를 포함한 보드 렌더링
export const renderBoard = (board, player) => {
  const displayBoard = board.map(row => [...row]);

  if (player) {
    player.tetromino.shape.forEach((row, y) => {
      row.forEach((value, x) => {
        if (value !== 0) {
          const boardY = y + player.pos.y;
          const boardX = x + player.pos.x;
          if (boardY >= 0 && boardY < BOARD_HEIGHT && boardX >= 0 && boardX < BOARD_WIDTH) {
            displayBoard[boardY][boardX] = player.tetromino.color;
          }
        }
      });
    });
  }

  return displayBoard;
};
